const DeleteModal = ({ isOpen, onClose, onConfirm, isDeleting }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-end z-[9999]">
      <div className="bg-white rounded-lg  max-w-sm w-full mx-4">
        <p className="mx-[62px] my-[29px] text-center leading-[24px] font-[400] font-geomanistBold text-[18px]">
          Are you sure you want to delete this payee?
        </p>

        <div className="flex border-t justify-end ">
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className=" font-geomanistBold  rounded-bl-md text-[20px] font-[400] py-2  text-red-600  hover:text-white w-1/2  hover:bg-red-600 disabled:opacity-50"
          >
            {isDeleting ? "Deleting..." : "Yes"}
          </button>
          <button
            onClick={onClose}
            disabled={isDeleting}
            className=" font-geomanistBold text-[20px]   rounded-br-md font-[400]  border-l py-2  w-1/2 hover:bg-gray-50"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};
export default DeleteModal;
